<template>
  <div>
    <div :class="['loading-area', loading ? 'loading' : '']">
      <div :class="['loading-area__content', loading ? 'loading' : '']">
        <div class="payout-card" v-for="(payout, key) in payouts" :key="key">
          <div class="grid-x align-middle">
            <div class="cell auto">
              <div class="grid-x grid-padding-x align-middle">
                <div class="cell auto">
                  <div class="payout-card__name" v-if="!vendor_id">{{ payout.vendor }}</div>
                  <div class="payout-card__date"><i>{{ payout.date }}</i></div>
                </div>

                <div class="cell shrink text-right">
                  <div class="payout-card__price">{{ payout.amount }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'

import moment from 'moment'

export default {
  mixins: [client, utils],
  props: [
    'vendor_id'
  ],
  data: function () {
    return {
      loading: false,
      payouts: []
    }
  },
  methods: {
    getPayouts: function () {
      this.loading = true
      this.payouts = []

      let request = '/vendors/payouts/'

      if (this.vendor_id) {
        request += '?vendor_id=' + this.vendor_id
      }

      this.request('get', request, {
        page_size: 5,
        ordering: '-created_date'
      }).then(response => {
        let items = response.results

        for (let i = 0; i < items.length; i++) {
          this.payouts.push({
            id: items[i].id,
            vendor: items[i].vendor_name,
            note: items[i].note,
            amount: this.formatMoney(items[i].amount),
            date: moment(items[i].created_date).format('MMM D, YYYY [at] h:mma')
          })
        }

        this.loading = false
      })
    }
  },
  created () {
    this.getPayouts()
  }
}
</script>

<style lang="scss">
@import '../../../styles/mixins';
@import '../../../styles/variables';

.payout-card {
  &__date {
    font-size: 14px;
    font-style: italic;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/vendors/sections/recentPayouts.vue